import { type MessageKey } from '@ecom/i18n';

/**
 * The auth form schemas (`schemas.ts`) carry i18n KEYS as their error messages, so one schema serves all three
 * languages. A message that is not a key — a zod default — falls back to the generic « invalid » text instead of being
 * shown raw.
 */
export function translateFieldError(
  t: (key: MessageKey) => string,
  message: string | undefined,
  fallback: MessageKey = 'auth.validation.email',
): string | undefined {
  if (message === undefined) return undefined;
  return message.startsWith('auth.') ? t(message as MessageKey) : t(fallback);
}
